import { h } from "vue";
import { message, Modal } from "ant-design-vue";
import router from "@/router";
import dayjs from "dayjs";
import { Button } from "ant-design-vue";
import { DownloadOutlined } from "@ant-design/icons-vue";

class NormalUtil {
  /**
   * 得到登入用户的id
   * @returns {string|null}
   */
  static getUserId = () => {
    if (localStorage.getItem("userid") != null) {
      return localStorage.getItem("userid");
    }
    return "-1";
  };

  static browseTempFile = (fileName) => {
    window.location.href =
      "http://" + process.env.VUE_APP_SERVER_ADDRESS + "/file/temp/" + fileName;
  };

  static twoPoint(val) {
    return (val / 100).toFixed(2);
  }

  static lpad2(val) {
    let s = "00" + val;
    return s.substring(s.length - 2);
  }

  static getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  /**
   * ResponseResult 后端传递过来的数据进行前端处理，200正常，无权限，token超时则显示重新登入
   * @param response 传递过来的数据
   * @constructor
   */
  static RRM(response, callback) {
    /**
     * 901 登入过期，请重新登入
     * 903 访问受限
     */
    switch (response.data.code) {
      case 200:
        callback();
        break;
      case 900:
        // 导入xls数据失败
        this.importWarning(response);
        break;
      case 901:
        Modal.info({
          title: "系统提示",
          content: "登入过期，请重新登入",
          okText: "重新登入",
          okType: "primary",
          onOk() {
            router.push("/login");
          },
        });
        break;
      case 903:
        Modal.warn({
          title: "系统提示",
          content: "您无权进行此项操作，如需此权限，请联系管理员!",
          okText: "确定",
          okType: "danger",
          onOk() {},
        });
        break;
      case 0:
        Modal.error({
          title: "系统提示",
          content: h(
            "div",
            {
              style: {
                maxHeight: "60vh", // 使用视口高度的60%，更灵活
                overflowY: "auto", // 内容超出时显示垂直滚动条
                padding: "8px 0", // 可选：调整内边距，避免内容贴边
              },
            },
            response.data.message
          ),
          okText: "确定",
          okType: "danger",
          onOk() {},
        });
        break;
      default:
        Modal.error({
          title: "系统错误",
          content: h(
            "div",
            {
              style: {
                maxHeight: "60vh", // 使用视口高度的60%，更灵活
                overflowY: "auto", // 内容超出时显示垂直滚动条
                padding: "8px 0", // 可选：调整内边距，避免内容贴边
              },
            },
            response.data.msg
          ),
          onOk() {},
        });

        break;
    }
  }

  /**
   * 得到导出文件的url
   * @param response
   * @returns {string}
   */
  static getExportExcelFile(response) {
    if (response.status !== 200) {
      // throw new Error("服务器返回异常，状态码：" + response.status);
      message.error("导出文件异常!");
      return null;
    }
    // 3. 生成 Blob 对象（类型匹配 .xlsx）
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName =
      router.currentRoute.value.path.replace("/", "") +
      "_" +
      dayjs().format("YYYYMMDDHHmmss") +
      ".xlsx";

    const handleDownload = () => {
      const link = document.createElement("a");
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      // 清理资源
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      }, 100);
    };

    const modal = Modal.success({
      title: "文件下载",
      footer: null,
      closable: true,
      content: (
        <div>
          <p className="j-text-primary">文件导出成功，点击下方按钮下载文件</p>
          <Button
            type="primary"
            danger
            onClick={handleDownload}
            style={{ marginTop: 16 }}
          >
            <DownloadOutlined />
            下载文件
          </Button>
          <Button type="link" onClick={() => modal.destroy()}>
            关闭
          </Button>
        </div>
      ),
    });
  }

  /**
   * Ajax响应错误提示, Display Ajax response error
   * @param error
   */
  static DARE(error) {
    Modal.error({
      title: "系统提示",
      content: error.data.status + " - " + error.data.error,
      okText: "确定",
      okType: "danger",
      onOk() {},
    });
  }

  /**
   * 分页查询数据，赋值分页信息
   * @param searchFormData
   * @param response
   */
  static pageInfo(searchFormData, response) {
    searchFormData.data.lastPage = response.data.data.last_page;
    searchFormData.data.total = response.data.data.total;
    searchFormData.data.page = response.data.data.current_page;
    searchFormData.data.size = response.data.data.per_page;
  }

  static success(message) {
    Modal.success({
      title: "系统提示",
      content: message,
      okText: "知道了",
      okType: "primary",
      onOk() {},
    });
  }

  static info(message) {
    Modal.info({
      title: "系统提示",
      content: message,
      okText: "知道了",
      okType: "primary",
      onOk() {},
    });
  }

  /**
   * 导入数据错误信息显示
   * @param response post返回对象{code, data, message}
   */
  static importWarning(response) {
    let msg = [];
    msg.push(h("h5", response.data.message));
    response.data.data.forEach(function (item) {
      msg.push(h("p", item));
    });

    Modal.warning({
      title: "导入数据提示",
      content: h(
        "div",
        {
          style: {
            maxHeight: "60vh", // 使用视口高度的60%，更灵活
            overflowY: "auto", // 内容超出时显示垂直滚动条
            padding: "8px 0", // 可选：调整内边距，避免内容贴边
          },
        },
        msg
      ),
      onOk() {},
    });
  }

  /**
   * 按指定url进行打印
   * @param url
   * @param key
   * @param toPdf
   * @param data
   * @param fileName
   * @returns {{toPdf, fileName, data, requestUrl, key}}
   */
  static printUrl(url, key, toPdf, data, fileName) {
    return {
      requestUrl: url,
      toPdf: toPdf,
      key: key,
      fileName: fileName,
      data: data,
    };
  }

  /**
   * 按当前url进行打印
   * @param key
   * @param toPdf
   * @param data
   * @param fileName
   * @returns {{toPdf, fileName, data, requestUrl: string, key}}
   */
  static print(key, toPdf, data, fileName) {
    return {
      requestUrl: router.currentRoute.value.path.replace("/", ""),
      toPdf: toPdf,
      key: key,
      fileName: fileName,
      data: data,
    };
  }
}

export default NormalUtil;
